import { BaseButton, Divider, Row, SizedBox } from "../CommonBaseComponents";
import CustomIcon from "../image/CustomIcon";
import { C4Text } from "../text/CustomText";
import styled from "styled-components";
import { useRef, useState } from "react";
import { useClickOutside } from "../../hooks/useClickOutside";
import MultiCheckedDropdownMenu from "../dropdown/MultiCheckedDropdownMenu";
import { Theme } from "../../Theme";

const MenuContainer = styled.div`
    position: relative;
    display: flex;
    align-items: center;
`;

export function CustomMultiFilterButton({
    icon,
    currentValues,
    setValues,
    values,
    multiText,
    openedLeftSide = false,
    iconWidth = "13.5px",
    iconHeight = "12px",
    onEmptySelect,
}) {
    const firstValue = values && values.length > 0 ? values[0].value : null;

    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
    };

    const menuRef = useRef(null);
    useClickOutside(menuRef, () => {
        if (isMenuOpen) {
            setIsMenuOpen(false);
        }
    });

    return (
        <MenuContainer ref={menuRef}>
            <BaseButton
                padding={"9px 10px"}
                border={
                    currentValues.includes(firstValue) && !isMenuOpen
                        ? `1px solid ${Theme.color.gray250}`
                        : `1px solid ${Theme.color.indigo500}`
                }
                borderRadius={"8px"}
                backgroundColor={currentValues.includes(firstValue) ? Theme.color.white : Theme.color.indigo500_005}
                hoverBackgroundColor={
                    currentValues.includes(firstValue) ? Theme.color.neutral100 : Theme.color.indigo500_01
                }
            >
                <Row alignItem={"center"} cursor={"pointer"}>
                    <Row alignItem={"flex-start"} cursor={"pointer"} onClick={toggleMenu}>
                        <CustomIcon iconName={icon} width={iconWidth} height={iconHeight} />
                        <SizedBox width={"7px"} />
                        <C4Text
                            fontColor={currentValues.includes(firstValue) ? Theme.color.zinc850 : Theme.color.indigo500}
                        >
                            {currentValues.length === 1
                                ? values.filter((v) => {
                                    return v.value === currentValues[0];
                                })[0]?.label
                                : `${multiText} (${currentValues.length})`}
                        </C4Text>
                    </Row>
                    <SizedBox width={"4px"} onClick={toggleMenu} />
                    <CustomIcon
                        iconName={isMenuOpen ? "chevron_up" : "chevron_down"}
                        isActive={!currentValues.includes(firstValue)}
                        size={"16px"}
                        cursor={"pointer"}
                        onClick={toggleMenu}
                    />
                    {!currentValues.includes(firstValue) && (
                        <>
                            <SizedBox width={"7px"} />
                            <Divider orientation={"vertical"} color={Theme.color.indigo500} height={"15px"} />
                            <SizedBox width={"7px"} />
                            <CustomIcon
                                iconName={"close_active"}
                                size={"16px"}
                                cursor={"pointer"}
                                onClick={() => setValues([firstValue])}
                            />
                        </>
                    )}
                </Row>
            </BaseButton>
            {isMenuOpen && (
                <MultiCheckedDropdownMenu
                    initValues={currentValues}
                    setValues={setValues}
                    values={values}
                    onClose={toggleMenu}
                    openedLeftSide={openedLeftSide}
                    onEmptySelect={onEmptySelect}
                />
            )}
        </MenuContainer>
    );
}
